import { render } from "./DeleteAddressModal.vue?vue&type=template&id=5f6298ac&scoped=true&ts=true"
import script from "./DeleteAddressModal.vue?vue&type=script&lang=ts"
export * from "./DeleteAddressModal.vue?vue&type=script&lang=ts"

import "./DeleteAddressModal.vue?vue&type=style&index=0&id=5f6298ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6298ac"]])

export default __exports__